import buscar from './buscarReducer';





export default {buscar
}

